import React from 'react';
import  GeneralScience2025  from 'views/GeneralScience2025';

const AccountGeneralPage = () => {
  return <GeneralScience2025 />;
};

export default AccountGeneralPage;